import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Checkbox, Tag} from "@blueprintjs/core";

import {SearchableDataGrid} from "../../../../components/tables/data-grid";
import * as AuthAPI from "../../../../services/auth-api";
import {organisations} from "../../../../services/api";
import {DataPageContext} from "../../context";
import {timeAgo} from "../../../../utils/time";
import {UsersForRole} from "./users-for-role";
import {CapabilitiesForRole} from "./capabilities-for-role";


const getRoleColumns = (onViewUsers, onViewCapabilities) => [
    {
        key: 'id',
        name: 'Id',
        width: 75,
        sortable: true,
        filterable: true,
    },
    {
        key: 'name',
        name: 'Name',
        resizable: true,
        sortable: true,
        filterable: true,
    },
    {
        key: 'auraAdminOnly',
        name: 'Internal only',
        width: 150,
        resizable: true,
        formatter: (params) => <Checkbox checked={!!params.row.auraAdminOnly} readOnly />
    },
    {
        key: 'createdAt',
        name: 'Created',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params) =>
            <span title={params.row.createdAt}>{timeAgo(params.row.createdAt)}</span>,
    },
    {
        key: 'updatedAt',
        name: 'Updated',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params) =>
            <span title={params.row.updatedAt}>{timeAgo(params.row.updatedAt)}</span>,
    },
    {
        key: 'users',
        name: 'Users',
        width: 80,
        formatter: (params) =>
            <Tag icon="people" interactive onClick={() => onViewUsers(params.row)}>Users</Tag>
    },
    {
        key: 'capabilities',
        name: 'Capabilities',
        width: 120,
        formatter: (params) =>
            <Tag icon="shield" interactive onClick={() => onViewCapabilities(params.row)}>Capabilities</Tag>
    },
];


const ManyRoles = () => {
    const {setLoading, setCount} = useContext(DataPageContext);
    const [data, setData] = useState(null);
    const [orgs, setOrgs] = useState([]);
    const [usersRole, setUsersRole] = useState(null);
    const [capsRole, setCapsRole] = useState(null);

    const columns = useMemo(() => getRoleColumns(setUsersRole, setCapsRole), []);

    useEffect(() => {
        setLoading({status: true, location: "Loading roles..."});
        Promise.all([
            AuthAPI.adminRoles.list(true),
            organisations.list(),
        ]).then(([rolesRes, orgsRes]) => {
            console.log("Loaded " + rolesRes.data.length + " roles");
            setData(rolesRes.data);
            setOrgs(orgsRes);
            setLoading({status: false, location: "Roles"});
        }).catch(error => {
            console.error(error);
            setLoading({status: false, location: "Failed to load roles..."});
            setData([]);
        });
    }, []);

    return <>
        <SearchableDataGrid
            columns={columns}
            data={data ?? []}
            defaultSort='id'
            onCount={(filtered, total) => setCount({filtered, total})}
        />
        <UsersForRole
            isOpen={!!usersRole}
            onClose={() => setUsersRole(null)}
            role={usersRole}
            allOrgs={orgs}
        />
        <CapabilitiesForRole
            isOpen={!!capsRole}
            onClose={() => setCapsRole(null)}
            role={capsRole}
        />
    </>;
}

export {ManyRoles};
